const Brochures = () => {
  return;
};

export default Brochures;
